import React from "react";
import { useTranslation } from "react-i18next";
import { styled } from "goober";
import { Button } from "clutch/src/Button/Button.jsx";

import { StackTrace } from "@/app/ErrorBoundary.style.jsx";
import BlitzHome from "@/inline-assets/blitz-home.svg";
import { useRoute } from "@/util/router-hooks.mjs";

export const Container = styled("div")`
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  > * {
    max-width: var(--sp-container);
    text-align: center;
    padding: 0 var(--sp-4) 0;
    > * {
      margin-inline: auto;
    }
    > :first-child {
      font-size: 3em;
    }
    > :not(:first-child) {
      margin-block-start: var(--sp-4);
      margin-block-end: var(--sp-4);
      color: var(--shade2);
    }
    > [type="button"] {
      display: inline-flex;
    }
  }
`;

function Missing() {
  const { t } = useTranslation();
  const subtitle = t("common:notFound", "Not found");
  const back = t("common:navigation.home", "Home");
  const route = useRoute();

  return (
    <Container>
      <div>
        <div>404</div>
        <div>{subtitle}</div>
        <StackTrace>{route?.currentPath}</StackTrace>
        <Button iconLeft={<BlitzHome />} href="/">
          {back}
        </Button>
      </div>
    </Container>
  );
}

export default Missing;
